<!-- 已办 -->
<template>
  <div>
    <!-- 查询区域 -->
    <!-- <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="5" :lg="7" :md="8" :sm="24">
            <a-form-item label="状态">
              <a-select placeholder="请选择状态" v-model="queryParam.applyState">
                <a-select-option :value="0">待审批</a-select-option>
                <a-select-option :value="1">待评价</a-select-option>
                <a-select-option :value="2">结束</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="用户编号">
              <j-input v-model="queryParam.userId" placeholder="请输入用户编号查询" />
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="用户姓名">
              <j-input v-model="queryParam.userName" placeholder="请输入用户姓名查询" />
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="用户电话">
              <j-input v-model="queryParam.userPhone" placeholder="请输入用户电话查询" />
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="申请类型">
              <a-select placeholder="请选择申请类型" v-model="queryParam.applyType">
                <a-select-option :value="0">报停</a-select-option>
                <a-select-option :value="1">报停恢复</a-select-option>
                <a-select-option :value="2">销户</a-select-option>
                <a-select-option :value="3">用户信息变更</a-select-option>
                <a-select-option :value="4">价格信息变更</a-select-option>
                <a-select-option :value="5">用户过户</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div> -->
    <!-- 查询区域-END -->
    
    <!-- table区域-begin -->
    <div class="table-fixed">
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">
    
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="applyType" slot-scope="text,record">
          {{record.applyType==0?$t('报停'):record.applyType==1?$t('报停恢复'):record.applyType==2?$t('销户'):record.applyType==3?$t('用户信息变更'):record.applyType==4?$t('价格信息变更'):record.applyType==5?$t('用户过户'):''}}
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleApprovalHistory(record)">{{ $t('审批历史') }}</a>
          <a-divider type="vertical" />
          <a @click="handleDetail(record,'detail')">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>

    <Modal ref="modalForm" @ok="modalFormOk"></Modal>
    <approvalHistoryModal ref="approvalHistoryModalForm" />
  </div>
</template>

<script>
  import JInput from '@/components/jeecg/JInput'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import Modal from '@/views/OAoffice/weChatApplicationApproval/modal.vue'
  import approvalHistoryModal from '@/views/OAoffice/weChatApplicationApproval/approvalHistoryModal'
  import { postAction,getAction } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';

  export default {
    name: 'ConstructionDetailList',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      Modal,
      approvalHistoryModal,
      JInput
    },
    props:{
      id:{
        type: String,
        default: ''
      }
    },
    data () {
      return {
        url: {
          list: "/jeecg-charge/meter/wechatUserApply/list",
        },
        dictOptions:{},
        superFieldList:[],
        disabledCurrentStart: null,
        disabledCurrentEnd: null,
        queryParam:{
          applyState:3
        }
      }
    },
    watch:{
      id(val){
        if(val){
          this.loadData();
        }
      }
    },
    created() {},
    // i18n：表头使用 computed 以响应语言切换
    computed: {
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('用户电话'),
            align:"center",
            dataIndex: 'userPhone',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('申请类型'),
            align:"center",
            dataIndex: 'applyType',
            scopedSlots: { customRender: 'applyType' },
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('申请时间'),
            align:"center",
            dataIndex: 'applyTime',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('审批人'),
            align:"center",
            dataIndex: 'updateBy',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('审批状态'),
            align:"center",
            dataIndex: 'isAgree',
            customRender: (t,r,index) => {
              if(t == 0){
                return this.$t('驳回')
              }else if(t == 1){
                return this.$t('通过')
              }else{
                return this.$t('撤销')
              }
            },
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('审批时间'),
            align:"center",
            dataIndex: 'updateTime',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:200,
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
    },
    methods: {
      loadData(){
        var params = this.getQueryParams();//查询条件
        params.applyState = 3;
        params.userId = this.id;
        getAction(this.url.list,params).then(res=>{
          if(res.success){
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      searchReset(){
        this.queryParam = {
          applyState: 3
        };
        this.loadData();
      },
      handleDetail(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row,'detail');
        });
      },
      handleApprovalHistory(row){
        this.$nextTick(()=>{
          this.$refs.approvalHistoryModalForm.init(row);
        });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>